export class ContactInfoCustomFieldRawDto {
  fieldName: string;
  fieldValue: boolean;
}
